import { ProgressSpinner } from "primereact/progressspinner";

import classes from "./Loader.module.scss";
import { classNames as cx } from "primereact/utils";

type LoaderProps = {
  pageLoader?: boolean;
};

export const Loader = ({ pageLoader }: LoaderProps) => {
  return (
    <div
      className={cx(classes.container, { [classes.pageLoader]: pageLoader })}
    >
      <ProgressSpinner className={classes.loader} />
    </div>
  );
};
